import yext from 'goog:yext';
import ajax from 'goog:yext.utils.ajax';
import ErrorDialog from '/src/com/yext/signup/signupui/js/errordialog';
const Uri = goog.require('goog.Uri');

import {triggerGTagEvent} from '/js/yext/gtag/gtag.js';

export default class SignUp extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      emailError: null,
      passwordError: null,
      signUpError: this.props.previousSignUpError === '' ? null : this.props.previousSignUpError,
      showSignInLoadingProgress: false,
      showGoogleLoadingProgress: false,
      showGithubLoadingProgress: false,
      googleDisabled: false,
      showGoogleError: false,
    };

    this.resetErrors = this.resetErrors.bind(this);
    this.validateEmailAndPassword = this.validateEmailAndPassword.bind(this);
    this.onSignIn = this.onSignIn.bind(this);
    this.onGoogleSignupBtnClick = this.onGoogleSignupBtnClick.bind(this);
    this.onGithubSignupBtnClick = this.onGithubSignupBtnClick.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.attachCustomGoogleButtonHandler = this.attachCustomGoogleButtonHandler.bind(this);
    this.onGoogleSignIn = this.onGoogleSignIn.bind(this);
    this.buildGithubSignUpUrl = this.buildGithubSignUpUrl.bind(this);
    this.addUtmParamsTo = this.addUtmParamsTo.bind(this);
    this.submitOnEnter = this.submitOnEnter.bind(this);
    this.handleSuccessfulSignup = this.handleSuccessfulSignup.bind(this);
    this.triggerGtmSuccessfulSignup = this.triggerGtmSuccessfulSignup.bind(this);
    this.auth2Google = null;
  }

  componentDidMount() {
    gapi.load('auth2', () => {
      // todo (young): figure out why the meta tag with client id is still needed in common.soy
      // for the below to work
      this.auth2Google = gapi.auth2.init({
        client_id: this.props.googleClientId,
        cookiepolicy: 'single_host_origin',
      });
      this.auth2Google.then(
        /* success */ () => this.attachCustomGoogleButtonHandler(),
        /* failure */ err => this.setState({googleDisabled: true}));
    });
  }

  resetErrors() {
    this.setState({
      emailError: null,
      passwordError: null,
      signUpError: null,
    });
  }

  isPasswordStrong(password) {
    return /\d/.test(password) && /[a-z]/i.test(password) && password.length >= 6;
  }

  validateEmailAndPassword(email, password) {
    isValid = true;

    // Email validation
    const emailRegex = /.+@.+\..+/;
    if (!email) {
      this.setState({emailError: yext.msg('Email is a required field')});
      isValid = false;
    } else if (!emailRegex.test(email)) {
      this.setState({emailError: yext.msg('Email format is invalid')});
      isValid = false;
    }

    // Password validation
    if (!password) {
      this.setState({passwordError: yext.msg('Password is a required field')});
      isValid = false;
    } else if (!this.isPasswordStrong(password)) {
      this.setState({passwordError: yext.msg('Password must be at least 6 characters and contain both a letter and a number')});
      isValid = false;
    }

    return isValid;
  }

  onSignIn() {
    this.resetErrors();

    const data = {};
    data['email'] = document.getElementById('yext-oauth__user-email').value;
    data['password'] = document.getElementById('yext-oauth__user-password').value;
    data['authenticityToken'] = this.props.authenticityToken;
    if (this.props.sessionId) {
      data['sessionId'] = this.props.sessionId;
    }
    this.addUtmParamsTo(data);

    isValidRequest = this.validateEmailAndPassword(data['email'], data['password']);

    if (isValidRequest && !this.state.submitting) {
      this.setState({
        showSignInLoadingProgress: true,
        submitting: true,
      });

      // clear login cookie
      this.handleLogout();

      ajax.post(
        '/signup/submit',
        /* success */ response => {
          if (!response['success']) {
            this.setState(
              {
                signUpError: response['errorMessage'],
                showSignInLoadingProgress: false,
                submitting: false,
              },
            );
          } else {
            this.handleSuccessfulSignup(response['redirect']);
          }
        },
        /* failure */ response => {
          this.setState(
            {
              signUpError: yext.msg('An error occurred, please try again'),
              showSignInLoadingProgress: false,
              submitting: false,
            },
          );
        },
        data,
      );
    }
  }

  handleLogout() {
    ajax.getNoResponse(
      '/users/logout',
      /* success */ () => {},
      /* failure */ () => {},
      {},
    );
  }

  onGoogleSignupBtnClick() {
    showGoogleError = this.state.googleDisabled;
    this.setState({
      showGoogleLoadingProgress: true,
      showGoogleError: showGoogleError},
    );
  }

  onGithubSignupBtnClick() {
    this.handleLogout();
    this.setState({showGithubLoadingProgress: true});

    const data = {};
    data['authenticityToken'] = this.props.authenticityToken;
    this.addUtmParamsTo(data);
    ajax.post(
      '/signup/updateUtmParamsForGitHub',
      /* success */ () => {
        // go to github and authenticate the user
        window.top.location.href = this.buildGithubSignUpUrl();

        if (sessionStorage) {
          sessionStorage.setItem('github-signup', 'true');
        }
      },
      /* failure */ () => {},
      data,
    );
  }

  attachCustomGoogleButtonHandler() {
    const element = document.getElementById('custom-google-signup-btn');
    this.auth2Google.attachClickHandler(
      element,
      {scope: 'profile email'},
      /* success */ this.onGoogleSignIn,
      /* failure */ () => {
        this.setState(
          {
            signUpError: yext.msg('An error occurred, please try again'),
            showGoogleLoadingProgress: false,
          },
        );
      },
    );
  }

  onGoogleSignIn(googleUser) {
    // clear login cookie
    this.handleLogout();

    const id_token = googleUser.getAuthResponse().id_token;

    const data = {};
    data['authenticityToken'] = this.props.authenticityToken;
    if (this.props.sessionId) {
      data['sessionId'] = this.props.sessionId;
    }
    if (id_token) {
      data['googleUserIdToken'] = id_token;
    }
    this.addUtmParamsTo(data);

    ajax.post(
      '/signup/submitGoogleOAuth',
      /* success */ response => {
        if (!response['success']) {
          this.setState(
            {
              signUpError: response['errorMessage'],
              showGoogleLoadingProgress: false,
            },
          );
        } else {
          this.handleSuccessfulSignup(response['redirect']);
        }
      },
      /* failure */ response => {
        this.setState(
          {
            signUpError: yext.msg('An error occurred, please try again'),
            showGoogleLoadingProgress: false,
          },
        );
      },
      data,
    );
  }

  buildGithubSignUpUrl() {
    const params = {};
    params['client_id'] = this.props.githubClientId;
    params['scope'] = 'user:email';
    const sessionIdSuffix = this.props.sessionId ? '?sessionId=' + this.props.sessionId : '';
    const signupUrl =
        window.location.protocol +
          '//' +
          window.location.hostname +
          '/signup/submitGitHubOAuth' +
          sessionIdSuffix;
    params['redirect_uri'] = signupUrl;
    params['state'] = this.props.authenticityToken;
    return new Uri('https://github.com/login/oauth/authorize')
      .setQueryData(Uri.QueryData.createFromMap(params));
  }

  addUtmParamsTo(data) {
    const DMTracking = window.top.YextDMTracking;
    let firstCookie; let lastCookie;
    if (DMTracking) {
      firstCookie = DMTracking.getFirstCookie();
      lastCookie = DMTracking.getLastCookie();
    }

    // Try to use cookie if it exists. The cookies are already supposed to grab URL params.
    let firstParams; let lastParams;
    if (firstCookie) {
      firstParams = new URLSearchParams(firstCookie);
    } else {
      firstParams = new URLSearchParams(window.top.location.search);
    }
    data['utm_firstParams'] = firstParams;
    if (lastCookie) {
      lastParams = new URLSearchParams(lastCookie);
    } else {
      lastParams = new URLSearchParams(window.top.location.search);
    }
    data['utm_lastParams'] = lastParams;
  }

  submitOnEnter(event) {
    if (event.charCode === 13) {
      this.onSignIn();
    }
  }

  // Handles a successful signup.
  handleSuccessfulSignup(redirect) {
    this.triggerGtmSuccessfulSignup(function() {
      window.top.location.href = redirect;
    });
  }

  // Should be called on successful account creation.
  triggerGtmSuccessfulSignup(callback) {
    triggerGTagEvent('signup-success', callback);
  }

  render() {
    // Email & Password Signup Button
    let signupButtonClasses = 'yext-oauth__button yext-oauth__button--submit';

    if (this.state.showSignInLoadingProgress) {
      signupButtonClasses += ' yext-oauth__button--primary--loading';
    } else {
      signupButtonClasses += ' yext-oauth__button--primary';
    }

    const signupButtonContent = this.state.showSignInLoadingProgress ? (
        <span className="yext-oauth__button-text--primary-loading">{yext.msg('Loading account...')}</span>
      ) : (
        <span>{yext.msg('Sign Up')}</span>
      );

    // OAuth Signup Buttons
    const oauthButtonClasses = 'yext-oauth__button yext-oauth__button--oauth-signup-option';
    let googleOAuthButtonClasses = '';
    let githubOAuthButtonClasses = '';

    if (this.state.showGoogleLoadingProgress) {
      googleOAuthButtonClasses = `${oauthButtonClasses} yext-oauth__button--secondary--loading`;
    } else {
      googleOAuthButtonClasses = `${oauthButtonClasses} yext-oauth__button--secondary`;
    }

    if (this.state.showGithubLoadingProgress) {
      githubOAuthButtonClasses = `${oauthButtonClasses} yext-oauth__button--secondary--loading`;
    } else {
      githubOAuthButtonClasses = `${oauthButtonClasses} yext-oauth__button--secondary`;
    }

    const googleOAuthButtonContent = this.state.showGoogleLoadingProgress ? (
        <span className="yext-oauth__button-text--secondary-loading">{yext.msg('Loading...')}</span>
      ) : (
        <span>{yext.msg('Google')}</span>
      );

    const githubOAuthButtonContent = this.state.showGithubLoadingProgress ? (
        <span className="yext-oauth__button-text--secondary-loading">{yext.msg('Loading...')}</span>
      ) : (
        <span>{yext.msg('Github')}</span>
      );

    let oAuthPageClasses = 'yext-oauth__page';

    if (this.props.isEmbeddedSignup === 'true') {
      oAuthPageClasses += ' yext-oauth__page--is-embedded';
    }

    return (
      <div className={oAuthPageClasses}>
        {this.props.isEmbeddedSignup === 'false' && (
          <React.Fragment>
            <img className="yext-oauth__yext-logo" alt="Yext logo" src="/users/public/images/logo-seal.svg" />
            <h2 className="yext-oauth__form-headline">{yext.msg('Create your free trial account.')}</h2>
          </React.Fragment>
        )}
        <div className="yext-oauth__container">
          <input id="yext-oauth__user-email" className="yext-oauth__input" name="email" type="email" placeholder="Email" maxLength="255" defaultValue={this.props.preFilledEmail}/>
          <ErrorDialog
            errorMessage={this.state.emailError}
          />
          <input id="yext-oauth__user-password" className="yext-oauth__input" name="password" type="password" onKeyPress={this.submitOnEnter} placeholder="Password" maxLength="60" />
          <ErrorDialog
            errorMessage={this.state.passwordError}
          />
          <p style={{'textAlign': 'left'}}>{yext.msg('Password must have at least 6 characters, including one letter and one number.')}</p>
          <button className={signupButtonClasses} type="submit" onClick={this.onSignIn} disabled={this.state.submitting}>
            {signupButtonContent}
          </button>
          <ErrorDialog
            errorMessage={this.state.signUpError}
          />

          <small>
            {yext.msg('By clicking Sign Up, you are confirming you have read and agree to the')} <a href="https://www.yext.com/terms/answers-free-trial-terms/" target="_blank" rel="noreferrer">{yext.msg('Search Free Trial Terms and Conditions')}</a>, {yext.msg('which will govern your access to and use of Yext products until such time as you enter into paid relationship with Yext')}.
          </small>

          {
            <div className="yext-oauth__divider">{yext.msg('or sign up with')}</div>
          }
          <div className="yext-oauth__oauth-signup-options">
            {
              <button type="button" href="#" target="_self" id="custom-google-signup-btn" className={googleOAuthButtonClasses} onClick={this.onGoogleSignupBtnClick}>
                <svg width="28" height="28" viewBox="0 0 533.5 544.3" xmlns="http://www.w3.org/2000/svg">
                  <path d="M533.5 278.4c0-18.5-1.5-37.1-4.7-55.3H272.1v104.8h147c-6.1 33.8-25.7 63.7-54.4 82.7v68h87.7c51.5-47.4 81.1-117.4 81.1-200.2z" fill="#4285f4"/>
                  <path d="M272.1 544.3c73.4 0 135.3-24.1 180.4-65.7l-87.7-68c-24.4 16.6-55.9 26-92.6 26-71 0-131.2-47.9-152.8-112.3H28.9v70.1c46.2 91.9 140.3 149.9 243.2 149.9z" fill="#34a853"/>
                  <path d="M119.3 324.3c-11.4-33.8-11.4-70.4 0-104.2V150H28.9c-38.6 76.9-38.6 167.5 0 244.4l90.4-70.1z" fill="#fbbc04"/>
                  <path d="M272.1 107.7c38.8-.6 76.3 14 104.4 40.8l77.7-77.7C405 24.6 339.7-.8 272.1 0 169.2 0 75.1 58 28.9 150l90.4 70.1c21.5-64.5 81.8-112.4 152.8-112.4z" fill="#ea4335"/>
                </svg>
                {googleOAuthButtonContent}
              </button>
            }
            {
              <button type="button" className={githubOAuthButtonClasses} onClick={this.onGithubSignupBtnClick}>
                <svg width="28" height="28" viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M8 0C3.58 0 0 3.58 0 8C0 11.54 2.29 14.53 5.47 15.59C5.87 15.66 6.02
                                15.42 6.02 15.21C6.02 15.02 6.01 14.39 6.01 13.72C4 14.09 3.48 13.23 3.32 12.78C3.23 12.55 2.84 11.84 2.5 11.65C2.22
                                11.5 1.82 11.13 2.49 11.12C3.12 11.11 3.57 11.7 3.72 11.94C4.44 13.15 5.59 12.81 6.05 12.6C6.12 12.08 6.33 11.73
                                6.56 11.53C4.78 11.33 2.92 10.64 2.92 7.58C2.92 6.71 3.23 5.99 3.74 5.43C3.66 5.23 3.38 4.41 3.82 3.31C3.82 3.31
                                4.49 3.1 6.02 4.13C6.66 3.95 7.34 3.86 8.02 3.86C8.7 3.86 9.38 3.95 10.02 4.13C11.55 3.09 12.22 3.31 12.22 3.31C12.66
                                4.41 12.38 5.23 12.3 5.43C12.81 5.99 13.12 6.7 13.12 7.58C13.12 10.65 11.25 11.33 9.47 11.53C9.76 11.78 10.01 12.26
                                10.01 13.01C10.01 14.08 10 14.94 10 15.21C10 15.42 10.15 15.67 10.55 15.59C13.71 14.53 16 11.53 16 8C16 3.58 12.42 0 8 0Z"
                  transform="scale(64)"
                  fill="#1B1F23"/>
                </svg>
                {githubOAuthButtonContent}
              </button>
            }
          </div>
          {this.state.showGoogleError && <ErrorDialog errorMessage={yext.msg('Please enable third-party cookies or disable private browsing to sign up with Google')}/>}
          <base target="_parent"></base>
          <p>
            {yext.msg('Already have an account?')} <a target="_parent" className="u-no-underline" href="/users/login">{yext.msg('Sign In')}</a>
          </p>
        </div>
      </div>
    );
  }
}
